import { action } from 'easy-peasy';
import { IActionSetSystemAlertsPagination } from '../types';

const setSystemAlertsPagination: IActionSetSystemAlertsPagination = action((state, pagination) => {
  state.pagination.total = pagination.total || state.pagination.total;
  state.pagination.pageNumber = pagination.pageNumber;
  state.pagination.pageSize = pagination.pageSize;
});

export default setSystemAlertsPagination;
